export default __webpack_public_path__ + "static/media/react.0616e6bd.svg";